module.exports = __webpack_public_path__ + "img/licheng.60a930ba.jpg";